import React from 'react';
import { CheckSquare, Download, MoreHorizontal, Plus, RotateCcw, UserPlus } from 'lucide-react';
import { Button } from '../ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '../ui/dropdown-menu';

export default function QuickActionsMenu({ onNewReservation, onNewWalkIn, onExport, onUndo }) {
  return (
    <div className="flex items-center gap-2">
      <Button size="sm" onClick={onNewReservation} className="hidden gap-1 bg-primary text-white shadow-sm hover:bg-primary/90 sm:flex">
        <Plus className="h-4 w-4" /> Neue Reservierung
      </Button>
      <Button size="sm" variant="secondary" onClick={onNewWalkIn} className="hidden gap-1 border shadow-sm sm:flex">
        <UserPlus className="h-4 w-4" /> Walk-In
      </Button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="outline" size="icon" className="h-9 w-9">
            <MoreHorizontal className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuLabel>Schnellaktionen</DropdownMenuLabel>
          <DropdownMenuItem onClick={onNewReservation} className="sm:hidden">
            <Plus className="mr-2 h-4 w-4" /> Neue Reservierung
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onNewWalkIn} className="sm:hidden">
            <UserPlus className="mr-2 h-4 w-4" /> Neuer Walk-In
          </DropdownMenuItem>
          <DropdownMenuSeparator />
          <DropdownMenuItem onClick={onExport}>
            <Download className="mr-2 h-4 w-4" /> CSV exportieren
          </DropdownMenuItem>
          <DropdownMenuItem disabled>
            <CheckSquare className="mr-2 h-4 w-4" /> Sammel-Check-in
          </DropdownMenuItem>
          <DropdownMenuItem onClick={onUndo} disabled={!onUndo}>
            <RotateCcw className="mr-2 h-4 w-4" /> Letzte Aktion rueckgaengig
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
